import CustomPaper from '../../containers/Paper'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

const PendingUserPage = () => {
    return (
        <CustomPaper className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-[700px] h-auto p-6 sm:p-10">
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 h-full">
                <div className="flex flex-col">
                    <span className="text-xl sm:text-3xl">
                        Esperá hasta que un administrador te de permiso.
                    </span>
                    <span className="text-xl sm:text-3xl">
                        Te llegará una respuesta a tu email.
                    </span>
                </div>
                <AccessTimeIcon className="text-[5rem] sm:text-[8rem] md:text-[10rem]" />
            </div>
        </CustomPaper>
    )
}

export default PendingUserPage
